export default "__VITE_ASSET__D48LaTXu__"